export const HQ_USER_TYPE = 'user';
export const HQ_COMPANY_TYPE = 'company';
export const HQ_ROLE_TYPE = 'role';
